module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-US":{"home":"Home","search_here":"Search here...","storage_used":"Storage Used:"},"zh-CHS":{"home":"首页","search_here":"搜索...","storage_used":"已使用："}}')
  delete Component.options._Ctor
}
